export default "__VITE_PUBLIC_ASSET__dce07553__"